import React, {useEffect, useState} from 'react'
import {Pagination} from "antd"
import CheckHotlineProvider from "./CheckHotlineProvider"
import moment from "moment/moment"
import CheckHotlineTable from "./table/CheckHotlineTable"
import parseToken from "../../../helpers/parseToken"
import {searchListCheck} from "../../../services/api/apiCheckHotLine"
import AddJobCheckHotline from "./action/AddJobCheckHotline"
import CheckHotlineSearch from "./search/CheckHotlineSearch"
import UseDebounce from "../../shared/UseDebounce"
import PopupListPhone from "./table/PopupListPhone"
import CirleIcon from "../../../statics/assets/icons/cycle.svg"

function CheckHotlinePage() {
    const [showFilter, setShowFilter] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [listJobCheck, setListJobCheck] = useState([])
    const [total, setTotal] = useState(0)
    const [idSelected, setIdSelected] = useState({})
    const [visible, setVisible] = useState(false)

    const [search, setSearch] = useState({
        fromListCreatedAt: moment().startOf('month'),
        toListCreatedAt: moment(),
        listCheckName: "",
        page: 1,
        limit: 20
    })

    const _setFiltersState = (params) => {
        setSearch({
            ...search,
            ...params
        })
    }

    const _onChangeValueId = (value) => {
        setIdSelected(value)
    }

    const _showModalListHotline = () => {
        setVisible(true)
    }

    const _closeModalListHotline = () => {
        setVisible(false)
        setIdSelected({})
    }

    function itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a href={() => false}>Previous</a>
        }
        if (type === 'next') {
            return <a href={() => false}>Next</a>
        }
        return originalElement
    }

    const _onChangeLimit = (page, pageSize) => {
        setSearch({
            ...search,
            limit: pageSize,
            page: pageSize !== search.limit ? 1 : page
        })
    }

    const _onToggleFilter = () => {
        setShowFilter(!showFilter)
    }

    const _fetchListJobCheckHotline = async () => {
        setLoading(true)
        setError('')

        try {
            const decodeToken = parseToken()

            const response = await searchListCheck(search, decodeToken.sub)

            const {success, data, error_message, totalRecord} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return setError(error_message)
            }

            setLoading(false)
            setListJobCheck(data)
            setTotal(totalRecord)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const debouncedListCheckName = UseDebounce(search.listCheckName, 500)

    useEffect(() => {
        _fetchListJobCheckHotline()
        // eslint-disable-next-line
    }, [search.toListCreatedAt, search.fromListCreatedAt, search.page, search.limit, debouncedListCheckName]);

    return (
        <CheckHotlineProvider
            listJobCheck={listJobCheck}
            onChangeValueId={_onChangeValueId}
            onShowModalListHotline={_showModalListHotline}
            fetchListJobCheckHotline={_fetchListJobCheckHotline}
        >
            <div className="ListCustomerPage PageDefault position-relative">
                <div className="PageHeading">
                    <h1 className="PageTitle">Check số hotline</h1>
                    <div className="PageFilterTop">
                        <div className="FiltersOpen" onClick={_onToggleFilter}>
                            <span className="material-icons Filter">filter_list</span>
                            <label>Bộ lọc</label>
                        </div>
                        <button className='ButtonCustom mr-1' onClick={() => _fetchListJobCheckHotline()}><CirleIcon
                            width={12} height={12}/>Refresh
                        </button>
                        <AddJobCheckHotline/>
                    </div>
                </div>

                {
                    showFilter && <CheckHotlineSearch filters={search} setFiltersState={_setFiltersState}/>
                }

                <div className="ContentPage">
                    <CheckHotlineTable loading={loading} error={error} listJobCheck={listJobCheck}/>
                    <div className="FooterTable">
                        <div className="Total">Show all {listJobCheck.length} items</div>
                        <Pagination
                            className="PaginationCustom"
                            showSizeChanger={true}
                            pageSizeOptions={[20, 50, 100, 200]}
                            total={total}
                            current={search.page}
                            pageSize={search.limit}
                            itemRender={itemRender}
                            onChange={_onChangeLimit}
                        />
                    </div>
                </div>
            </div>

            <PopupListPhone visible={visible} idListHotline={idSelected} onCancel={_closeModalListHotline}/>
        </CheckHotlineProvider>
    )
}

export default CheckHotlinePage
